export { EljurIntegrationEntity } from './eljur-integration-entity';

export type { Entity as EljurIntegrationEntityType } from './eljur-integration-entity';
